/**
 * Creates an Elasticsearch runtime field that converts subeventStartTime
 * from UTC to a local timezone and emits the local date as a keyword.
 *
 * This is used for date facet aggregation in non-UTC timezones (e.g., GZ/CET).
 */
export function createLocalDateRuntimeField(timezone: string) {
  return {
    subeventStartDateLocal: {
      type: 'keyword' as const,
      script: {
        source: `
          if (doc['subeventStartTime'].size() == 0) {
            emit('');
            return;
          }
          ZonedDateTime utcTime = doc['subeventStartTime'].value;
          ZoneId targetZone = ZoneId.of(params.tz);
          ZonedDateTime localTime = utcTime.withZoneSameInstant(targetZone);
          emit(localTime.toLocalDate().toString());
        `,
        params: { tz: timezone },
      },
    },
  };
}
